import parsePhoneNumberFromString from 'libphonenumber-js'
import * as z from 'zod'
import {t} from '../../../../lib/utils/localization'
import type {FormFieldValidation} from '../../../../schemas/contentful/contentTypes/formFieldValidation'
import regex from './regex'

type ValidationBody = {
  message: string
  schema: z.ZodType
}

type Validations = Record<FormFieldValidation['fields']['name'], ValidationBody>

const validations: Validations = {
  REQUIRED: {
    message: t('This field is required.'),
    schema: z.string().trim().min(1),
  },
  WORK_EMAIL_ONLY: {
    message: t('Please enter a valid work email address.'),
    schema: z.email().refine(email => !regex.EMAIL_PERSONAL_DOMAIN_REGEX.test(email), {
      message: t('The email is from a personal email provider.'),
    }),
  },
  EMAIL: {
    message: t('Please enter a valid email address.'),
    schema: z.email(),
  },
  PHONE: {
    message: t('Please enter a valid phone number.'),
    schema: z
      .string()
      .trim()
      .refine(value => {
        const phoneNumber = parsePhoneNumberFromString(value, {extract: false})
        return phoneNumber !== undefined && phoneNumber.isPossible()
      }),
  },
} as const

export {validations as ContentfulValidations}

export function getValidation(validation: FormFieldValidation): ValidationBody {
  const base = validations[validation.fields.name]
  const customMessage = validation.fields.errorMessage
  if (typeof customMessage === 'string' && customMessage.trim().length > 0) {
    return {
      ...base,
      message: customMessage,
    }
  }
  return base
}
